const Urls = (function () {

    const _log = console.log;
    const _warn = console.warn;
    const _error = console.error;

    let data;

    function init () {
        return fetchData();
    }

    function fetchData () {
        return $.getJSON('/data/urls.json')
            .then((res) => {
                data = res;
            })
            .catch(e => _error(e))
    }

    function getData () {
        return data;
    }

    function getUrl (city) {
        let matches = data.filter(row => {
            if (row.City) return row.City.toLowerCase() === city.toLowerCase()
        });
        if (matches.length) {
            let url = matches[0]['URL'] || matches[0]['url'];
            if (!url) return null;
            let match = url.match(new RegExp('//www\\.hotels\\.com/[0-9a-z]+/', 'gi'));
            if (match) return match[0];
            return null;
        }
        if (!matches.length || matches.length > 1) {
            _warn(`Missing url for '${city}'`);
        }
        return null;
    }

    function registerEvents () {
    }


    return { init, getUrl, getData }
})()
